import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  fonts: {
    heading: 'Inter, sans-serif',
    body: 'Inter, sans-serif',
  },
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  colors: {
    brand: {
      50: '#e6f7ff',
      100: '#b3e0ff',
      200: '#80caff',
      300: '#4db3ff',
      400: '#1a9dff',
      500: '#0080ff',
      600: '#0066cc',
      700: '#004d99',
      800: '#003366',
      900: '#001a33',
    },
    primary: {
      50: '#e6f7ff',
      100: '#b3e0ff',
      200: '#80caff',
      300: '#4db3ff',
      400: '#1a9dff',
      500: '#0080ff',
      600: '#0066cc',
      700: '#004d99',
      800: '#003366',
      900: '#001a33',
    },
    secondary: {
      50: '#fff5e6',
      100: '#ffe0b3',
      200: '#ffcc80',
      300: '#ffb84d',
      400: '#ffa31a',
      500: '#ff8f00',
      600: '#cc7200',
      700: '#995600',
      800: '#663900',
      900: '#331d00',
    },
  },
  components: {
    Button: {
      variants: {
        primary: {
          bg: 'primary.600',
          color: 'white',
          _hover: {
            bg: 'primary.700',
          },
          _active: {
            bg: 'primary.800',
          },
        },
        secondary: {
          bg: 'secondary.600',
          color: 'white',
          _hover: {
            bg: 'secondary.700',
          },
          _active: {
            bg: 'secondary.800',
          },
        },
      },
    },
    Card: {
      baseStyle: {
        p: 6,
        bg: 'white',
        borderRadius: 'xl',
        shadow: 'lg',
        border: '1px solid',
        borderColor: 'gray.200',
      },
      variants: {
        elevated: {
          shadow: 'xl',
          _hover: {
            shadow: '2xl',
          },
        },
        interactive: {
          cursor: 'pointer',
          transition: 'shadow 0.2s',
          _hover: {
            shadow: 'xl',
          },
        },
      },
    },
  },
  breakpoints: {
    base: '0em',
    sm: '30em',
    md: '48em',
    lg: '62em',
    xl: '80em',
    '2xl': '96em',
  },
});

export default theme;